(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("npotag", [], factory);
	else if(typeof exports === 'object')
		exports["npotag"] = factory();
	else
		root["npotag"] = factory();
})(this, function() {
return 